var zhTW = {
	"codeBlock.copied": "已複製",
	"codeBlock.copyLabel": "複製",
	"inlineCodeBlock.copied": "已複製",
	"inlineCodeBlock.copyLabel": "複製內嵌程式碼"
};

export { zhTW as default };
